// @flow
import { createAction } from 'redux-actions';

const RECEIVE_HOMES = 'hive/homes/RECEIVE_HOMES';
const RENAMED_HOME = 'hive/homes/RENAMED_HOME';
const GET_HOMES = 'hive/homes/GET_HOMES';
const RENAME_HOME = 'hive/homes/RENAME_HOME';

export const receiveHomes = createAction(RECEIVE_HOMES);
export const getHomes = createAction(GET_HOMES);
export const renameHome = createAction(RENAME_HOME);
export const renamedHome = createAction(RENAMED_HOME);



// WEBPACK FOOTER //
// ./src/core/state/homes/actions.js